// @flow
import type { BundleActionType } from './actions';
import type { RoamingPackage } from 'digicel-kaizen-library';

const initialState = {
  roaming: {},
};

export const bundleReducer = (state: BundleStateType = initialState, action: BundleActionType): BundleStateType => {
  switch (action.type) {
    case 'SET_ROAMING_BUNDLES':
      return {
        ...state,
        roaming: action.payload,
      };
    default:
      return state;
  }
};

export type BundleStateType = {
  roaming: { [string]: RoamingPackage },
};
